<template>
  <ul class="nav nav-tabs">
    <li v-for="option in options" :key="option.value">
      <a href="#" :title="option.title" class="nav-link"
         :class="{active: option.value === activeTab, [classForActive]: option.value === activeTab}"
         @click.prevent="$emit('select', option.value)">
        {{ option.label }}
      </a>
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    activeTab: {
      type: String,
      required: true
    },
    classForActive: {
      type: String,
      required: false
    },
    options: {
      type: Array,
      required: true
    }
  },

  emits: ['select']
}
</script>
